const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined'

const isWebWorker =
  typeof self === 'object' &&
  self.constructor &&
  self.constructor.name === 'DedicatedWorkerGlobalScope'

const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'

export const isTestEnv = process.env.NODE_ENV === 'test'

export const isNode = (): boolean => !(isBrowser || isWebWorker || isReactNative)
